export default __webpack_public_path__ + "static/google-cloud-logo-732958bc0857c17aa7d9962adaf82832.png";